<template>
  <div>
    <div class="form-group row mt-5 mb-4">
      <label class="col-sm-4">Mire kíván biztosítást kötni:</label>
      <div class="col-sm-8">
        <span v-if="contractFor == 1">Ingatlan és ingóság</span>
        <span v-if="contractFor == 2">Csak ingatlan</span>
        <span v-if="contractFor == 3">Csak ingóság</span>
      </div>
    </div>
    <div v-if="contractFor !== 3">
      <div class="form-group row mb-2">
        <label class="col-sm-4">Milyen típusú a biztosítani kívánt ingatlan?</label>
        <div class="col-sm-8">{{ stringPropertyType }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Az ingatlan külterületen helyezkedik el?</label>
        <div class="col-sm-8">{{ propertyOutskirts ? 'Igen' : 'Nem' }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4"
          >Folytatnak-e olyan vállalkozási tevékenységet az ingatlanban, ami nem szellemi
          munkavégzés?</label
        >
        <div class="col-sm-8">{{ propertyPhysicalJob ? 'Igen' : 'Nem' }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Az ingatlan tulajdonjoga:</label>
        <div class="col-sm-8">{{ stringPropertyOwnType }}</div>
      </div>
      <div class="form-group row mb-5">
        <label class="col-sm-4">Az ingatlan irányítószáma:</label>
        <div class="col-sm-8">{{ propertyZip }}</div>
      </div>
      <h1>Főépület adatai</h1>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Mekkora az épület/ingatlan hasznos alapterülete?</label>
        <div class="col-sm-8">{{ insurancePropertyFloor }} m2</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Az Ön által választott biztosítási összeg:</label>
        <div class="col-sm-8">{{ insurancePropertyInsurance | currency }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Az ingatlan építési éve:</label>
        <div class="col-sm-8">{{ insurancePropertyBuiltYear }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Életvitelszerűen tartozkodó lakók</label>
        <div class="col-sm-8">{{ insurancePropertyResidents }} fő</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Ingatlan falazata</label>
        <div class="col-sm-8">{{ stringPropertyWall(insurancePropertyWall) }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Ingatlan tetőzete</label>
        <div class="col-sm-8">{{ stringPropertyRoof(insurancePropertyRoof) }}</div>
      </div>
      <div v-if="sideBuildings.length > 0" class="mt-5">
        <h1>Melléképületek adatai</h1>
        <div v-for="(building, key) in sideBuildings" :key="key" class="mb-2">
          <h2 v-if="sideBuildings.length > 1">{{ key + 1 }}. melléképület adatai</h2>
          <div class="form-group row mb-2">
            <label class="col-sm-4">Melléképület alapterülete</label>
            <div class="col-sm-8">{{ building.floorArea }} m2</div>
          </div>
          <div class="form-group row mb-2">
            <label class="col-sm-4">Melléképület falazata</label>
            <div class="col-sm-8">{{ stringPropertyWall(building.wallType) }}</div>
          </div>
          <div class="form-group row">
            <label class="col-sm-4">Melléképület tetőzete</label>
            <div class="col-sm-8">{{ stringPropertyRoof(building.roofType) }}</div>
          </div>
        </div>
        <hr />
        <div class="form-group row">
          <label class="col-sm-4">Választott biztosítási összeg</label>
          <div class="col-sm-8">{{ sideBuildingsInsurance | currency }}</div>
        </div>
      </div>
    </div>
    <div v-if="contractFor !== 2" class="mt-5">
      <h1>Ingóságok</h1>
      <div class="form-group row mb-2" v-if="acceptCalculatedInsurance">
        <label class="col-sm-4">Ajánlott biztosított ingóság ár</label>
        <div class="col-sm-8">{{ calculatedInsurancePrice | currency }}</div>
      </div>
      <div class="form-group row mb-2" v-if="!acceptCalculatedInsurance && priceType === 'full'">
        <label class="col-sm-4">Megadott biztosított ingóság ár</label>
        <div class="col-sm-8">{{ allGoodsPrice | currency }}</div>
      </div>
      <div class="form-group row mb-2" v-if="!acceptCalculatedInsurance && priceType === 'partial'">
        <label class="col-sm-4">Részletezett biztosított ingóság ár</label>
        <div class="col-sm-8">{{ detailedInsurePrice | currency }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Értéktárgyak 200 000 forint limitig</label>
        <div class="col-sm-8">{{ valuablesUnder200 | currency }}</div>
      </div>
      <div class="form-group row" v-if="sideBuildings.length > 0">
        <label class="col-sm-4">Melléképület ingóságainak becsült értéke</label>
        <div class="col-sm-8">{{ sideBuildingsGoodsPrice | currency }}</div>
      </div>
    </div>
    <h1 class="mt-5">Kiegészítők</h1>
    <div class="mb-4" v-if="Object.keys(chosenAccesories).length <= 0">
      Ön nem választott ki egyetlen kiegészítőt sem.
    </div>
    <div class="row p-3 mb-4" v-else>
      <div class="col-12 mb-3" v-for="(accesory, key) in chosenAccesories" :key="key">
        <Accesory :accesory="accesory" :aKey="key" :selectable="false" />
      </div>
    </div>
    <h1>Díjfizetés és kedvezmények</h1>
    <div class="form-group row mb-2">
      <label class="col-sm-4">A biztosítás éves alapdíja:</label>
      <div class="col-sm-8">
        {{ $store.state.chooseableAccesories.accessorySumPrice | currency }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">A kiegészítők díja összesen:</label>
      <div class="col-sm-8">{{ $store.state.eves_dij_plus | currency }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">A biztosítás éves díja összesen:</label>
      <div class="col-sm-8">{{ $store.state.kieg_emelt_eves_dij | currency }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Az Ön által választott díjfizetési gyakoriság szerinti díj:</label>
      <div class="col-sm-8">{{ paymentFrequentString }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Díjfizetés módja</label>
      <div class="col-sm-8">{{ stringPaymentType }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Díjfizetés gyakorisága</label>
      <div class="col-sm-8">{{ stringPaymentFrequency }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Elektronikus kommunikáció</label>
      <div class="col-sm-8">{{ electronicContact ? 'Igen' : 'Nem' }}</div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4">Elektronikus kárrendezés</label>
      <div class="col-sm-8">{{ electronicInsuring ? 'Igen' : 'Nem' }}</div>
    </div>
    <h1 class="mt-5">Személyes adatok</h1>
    <div class="form-group row">
      <label class="col-sm-4">Kockázatviselés kezdete:</label>
      <div class="col-sm-8">{{ new Date(riskStartDate).toLocaleDateString('hu-HU') }}</div>
    </div>
    <h2 class="mt-4">Kockázatviselés helye</h2>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Irányítószám:</label>
      <div class="col-sm-8">{{ propertyZip }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Település neve:</label>
      <div class="col-sm-8" v-if="typeof propertyName === 'object' && propertyName.length > 0">
        {{ selectedPropertyName }}
      </div>
      <div class="col-sm-8" v-else>{{ propertyName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Közterület neve:</label>
      <div class="col-sm-8">{{ riskLocationName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Közterület jellege:</label>
      <div class="col-sm-8">{{ riskLocationType }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Házszám:</label>
      <div class="col-sm-8">{{ riskLocationHouseNumber }}</div>
    </div>
    <div class="form-group row mb-2mb-2" v-if="riskLocationBuilding !== ''">
      <label class="col-sm-4">Épület, lépcsőház, emelet, ajtó:</label>
      <div class="col-sm-8">{{ riskLocationBuilding }}</div>
    </div>
    <div class="form-group row" v-if="riskLocationTopography !== ''">
      <label class="col-sm-4">Helyrajzi szám:</label>
      <div class="col-sm-8">{{ riskLocationTopography }}</div>
    </div>
    <h2 class="mt-4">Szerződő adatai</h2>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Szerződő vezetékneve:</label>
      <div class="col-sm-8">{{ contractLastName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Szerződő keresztneve:</label>
      <div class="col-sm-8">{{ contractFirstName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Szerződő születéskori neve:</label>
      <div class="col-sm-8">{{ contractBornName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Szerződő anyja leánykori neve:</label>
      <div class="col-sm-8">{{ contractMotherChildName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Szerződő születési helye:</label>
      <div class="col-sm-8">{{ contractBornCity }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Szerződő születési dátuma:</label>
      <div class="col-sm-8">{{ new Date(contractBornDate).toLocaleDateString('hu-HU') }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Szerződő email címe:</label>
      <div class="col-sm-8">{{ contractEmail }}</div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4">Szerződő telefonszáma:</label>
      <div class="col-sm-8">+36 {{ contractPhoneNumberArea }} {{ contractPhoneNumber }}</div>
    </div>
    <div v-if="!contractPostAddressIsTheSame">
      <h2 class="mt-4">Levelezési cím</h2>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Irányítószám:</label>
        <div class="col-sm-8">{{ contractLocationZip }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Település neve:</label>
        <div
          class="col-sm-8"
          v-if="
            typeof contractLocationCity === 'object' &&
              contractLocationCity &&
              contractLocationCity.length > 0
          "
        >
          {{ contractSelectedLocationName }}
        </div>
        <div class="col-sm-8" v-else>{{ contractLocationCity }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Közterület neve:</label>
        <div class="col-sm-8">{{ contractLocationName }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Közterület jellege:</label>
        <div class="col-sm-8">{{ contractLocationType }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Házszám:</label>
        <div class="col-sm-8">{{ contractLocationHouseNumber }}</div>
      </div>
      <div class="form-group row mb-2" v-if="contractLocationBuilding !== ''">
        <label class="col-sm-4">Épület, lépcsőház, emelet, ajtó:</label>
        <div class="col-sm-8">{{ contractLocationBuilding }}</div>
      </div>
      <div class="form-group row" v-if="contractLocationTopography !== ''">
        <label class="col-sm-4">Helyrajzi szám:</label>
        <div class="col-sm-8">{{ contractLocationTopography }}</div>
      </div>
    </div>
    <h2 class="mt-4">Biztosított adatai</h2>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított vezetékneve:</label>
      <div class="col-sm-8">{{ contractedIsInsured ? contractLastName : insuredLastName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított keresztneve:</label>
      <div class="col-sm-8">{{ contractedIsInsured ? contractFirstName : insuredFirstName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított születéskori neve:</label>
      <div class="col-sm-8">{{ contractedIsInsured ? contractBornName : insuredBornName }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított anyja leánykori neve:</label>
      <div class="col-sm-8">
        {{ contractedIsInsured ? contractMotherChildName : insuredMotherChildName }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított születési helye:</label>
      <div class="col-sm-8">{{ contractedIsInsured ? contractBornCity : insuredBornCity }}</div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított születési dátuma:</label>
      <div class="col-sm-8">
        {{
          new Date(contractedIsInsured ? contractBornDate : insuredBornDate).toLocaleDateString(
            'hu-HU'
          )
        }}
      </div>
    </div>
    <div class="form-group row mb-2">
      <label class="col-sm-4">Biztosított email címe:</label>
      <div class="col-sm-8">{{ contractedIsInsured ? contractEmail : insuredEmail }}</div>
    </div>
    <div class="form-group row">
      <label class="col-sm-4">Biztosított telefonszáma:</label>
      <div class="col-sm-8">
        +36 {{ contractedIsInsured ? contractPhoneNumberArea : insuredPhoneNumberArea }}
        {{ contractedIsInsured ? contractPhoneNumber : insuredPhoneNumber }}
      </div>
    </div>
    <div v-if="propertyIsMortgaged" class="mt-4">
      <h2>Jelzálog</h2>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Hitelező cég neve:</label>
        <div class="col-sm-8">{{ mortgageCreditor }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Hitelező cég székhelye:</label>
        <div class="col-sm-8">{{ mortgageCreditorLocation }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Hitelszerződés azonosítója:</label>
        <div class="col-sm-8">{{ mortgageId }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Hitel összege és devizaneme:</label>
        <div class="col-sm-8">{{ mortgagePrice }} {{ mortgageCurrency }}</div>
      </div>
      <div class="form-group row mb-2">
        <label class="col-sm-4">Hitel kezdete:</label>
        <div class="col-sm-8">
          {{ mortgageStartDate ? new Date(mortgageStartDate).toLocaleDateString('hu-HU') : '' }}
        </div>
      </div>
      <div class="form-group row">
        <label class="col-sm-4">Hitel lejárata:</label>
        <div class="col-sm-8">
          {{ mortgageEndDate ? new Date(mortgageEndDate).toLocaleDateString('hu-HU') : '' }}
        </div>
      </div>
    </div>
    <h1 class="h2 mt-4">E-mail megerősítés</h1>
    <div class="form-group row mb-2">
      <label class="col-sm-4" for="email_validation_code">E-mailben kapott kód:</label>
      <ValidationProvider
        rules="required|email_verify_code"
        v-slot="{errors, classes}"
        class="col-sm-4"
      >
        <input
          type="number"
          class="form-control dark-border"
          id="email_validation_code"
          name="email_validation_code"
          v-model="emailVerifyToken"
          :disabled="emailVerified"
          :class="{'is-valid': emailVerified, classes}"
        />
        <small id="email_validation_code-error" class="text-danger input-alert">{{
          errors[0]
        }}</small>
      </ValidationProvider>
    </div>
    <div class="form-group row mb-2" v-if="merchant_id">
      <label class="col-sm-4" for="merchant_email">Biztosításközvetítő e-mail címe:</label>
      <ValidationProvider rules="email" v-slot="{errors, classes}" class="col-sm-4">
        <input
          type="email"
          class="form-control"
          id="merchant_email"
          name="merchant_email"
          v-model="merchantEmail"
          :class="classes"
        />
        <small id="merchant_email-error" class="text-danger input-alert">{{ errors[0] }}</small>
      </ValidationProvider>
    </div>
    <div class="text-danger">
      Az e-mail cím megerősítése után az e-mail cím módosítása a későbbiekben már nem lehetséges.
    </div>
    <h1 class="h2 mt-4">Nyilatkozatok</h1>
    <div class="form-group">
      <div class="form-check mb-4">
        <ValidationProvider name="biztositasi_feltetelek" rules="required_checkbox">
          <input
            type="checkbox"
            class="form-check-input"
            id="biztositasi_feltetelek"
            name="nyilatkozatok[]"
            value="biztositasi_feltetelek"
            v-model="electronicCommunation"
          />
        </ValidationProvider>
        <label for="biztositasi_feltetelek" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Biztosítási szabályzat és Biztosítási termékismertető elfogadása
            <!-- <button
              :class="insuranceTermsOpened ? 'arrow-up' : 'arrow-down'"
              @click="insuranceTermsClick"
            ></button> -->
            <button aria-label="szabalyzat-text-expand" @click="insuranceTermsClick" type="button">
              <svg
                v-if="insuranceTermsOpened"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="#b0001f"
                class="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="#b0001f"
                class="bi bi-caret-up-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                />
              </svg>
            </button> </b
          ><br />
          <div v-show="insuranceTermsOpened">
            Kijelentem, hogy megismertem és elfogadom a Colonnade Minősített Fogyasztóbarát
            Otthonbiztosítás Biztosítási Feltételeit és Ügyféltájékoztatóját, illetve a Biztosítási
            termékismertetőjét.
            <iframe
              title="pdf_viewer"
              class="w-100 mt-2"
              style="height: 500px;"
              src="https://www.colonnade.hu/media/colonnade-minositett-fogyasztobarat-otthonbiztositas-biztositasi-feltetelek-es-ugyfeltajekoztato"
              frameborder="0"
            ></iframe>
            <br />
            <iframe
              title="pdf_viewer_ipid"
              class="w-100 mt-2"
              style="height: 500px;"
              src="https://www.colonnade.hu/media/colonnade-minositett-fogyasztobarat-otthonbiztositas-biztositasi-termekismerteto"
              frameborder="0"
            ></iframe>
          </div>
        </label>
      </div>
      <div class="form-check mb-4">
        <input
          type="checkbox"
          class="form-check-input"
          id="hirlevel"
          name="nyilatkozatok[]"
          value="hirlevel"
          v-model="marketingMails"
        />
        <label for="hirlevel" class="form-check-label">
          <b>Szeretnék értesülni az aktuális ajánlatokról, akciókról</b><br />
          Kijelentem, hogy önkéntesen hozzájárulok ahhoz, hogy a Colonnade Insurance S.A.
          Magyarországi Fióktelepe a megadott személyes adataimat (név, telefonszám, e-mail cím)
          közvetlen üzletszerzés céljából kezelje és azokon megkeressen. Hozzájárulásomat bármikor,
          korlátozás és indoklás nélkül, ingyenesen visszavonhatom az info@colonnade.hu címre
          küldött emailben.
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider name="adatvedelmi_nyilatkozat" rules="required_checkbox">
          <input
            type="checkbox"
            class="form-check-input"
            id="adatvedelmi_nyilatkozat"
            name="nyilatkozatok[]"
            value="adatvedelmi_nyilatkozat"
            v-model="privacyStatement"
          />
        </ValidationProvider>
        <label for="adatvedelmi_nyilatkozat" class="form-check-label">
          <span class="text-danger">*</span>&nbsp; Tudomásul veszem, hogy a Colonnade Insurance S.A.
          Magyarországi Fióktelepe (székhely: 1134 Budapest, Váci út 23-27.) adatkezelő által a
          <a href="https://colonnade.nopa.hu" target="_blank">https://colonnade.nopa.hu</a>
          felhasználói adatbázisában tárolt személyes adataim átadásra kerülnek az OTP Mobil Kft.,
          mint adatfeldolgozó részére. Amennyiben más személyek személyes adatait adtam meg (vagy
          fogom megadni) a Biztosítónak, kijelentem, hogy az érintett személyeket tájékoztattam az
          adatvédelmi szabályzat tartalmáról, illetve ezen rendelkezéseknek megfelelően fel vagyok
          hatalmazva az érintett személyek személyes adatainak továbbítására a Biztosító részére. A
          Biztosító adatvédelmi szabályzata közvetlenül
          <a href="https://www.colonnade.hu/media/colonnade-adatvedelmi-tajekoztato" target="_blank"
            >itt</a
          >
          elérhető.
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider name="tudomasul_veszem" rules="required_checkbox">
          <input
            type="checkbox"
            class="form-check-input"
            id="tudomasul_veszem"
            name="nyilatkozatok[]"
            value="tudomasul_veszem"
            v-model="acceptTerms"
          />
        </ValidationProvider>
        <label for="tudomasul_veszem" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Biztosításkötéssel kapcsolatos nyilatkozat
            <!-- <button
              type="button"
              :class="insuranceBondStatementOpened ? 'arrow-up' : 'arrow-down'"
              @click="insuranceBondStatementClick"
            ></button
          > -->
            <button
              aria-label="nyilatkozat-text-expand"
              @click="insuranceBondStatementClick"
              type="button"
            >
              <svg
                v-if="insuranceBondStatementOpened"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="#b0001f"
                class="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="#b0001f"
                class="bi bi-caret-up-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                />
              </svg>
            </button>
          </b>
          <ul v-show="insuranceBondStatementOpened">
            <b>Tudomásul veszem, hogy:</b>
            <li>
              jelen ajánlat a Biztosító kockázat elbírálásának alapja;
            </li>
            <li>
              a Biztosítónak az ajánlattételtől számítva 15 nap áll rendelkezésére az ajánlat
              elbírálására;
            </li>
            <li>
              a Biztosító a kockázatelbírálás eredményeként az ajánlatot indoklás nélkül
              visszautasíthatja, ebben az esetben a biztosítási szerződés nem jön létre;
            </li>
            <li>
              ha a biztosítási esemény a kockázatelbírálási idő alatt bekövetkezik, a Biztosító az
              ajánlatot csak abban az esetben utasíthatja vissza, ha az igényelt biztosítási fedezet
              jellege vagy a kockázatviselés körülményei alapján nyilvánvaló, hogy az ajánlat
              elfogadásához a kockázat egyedi elbírálása szükséges;
            </li>
            <li>
              az ajánlattételkor befizetett összeget a Biztosító díjelőlegként kezeli, az ajánlat
              elfogadása esetén pedig díjfizetésnek tekinti, amennyiben a Biztosító az ajánlatot
              elutasítja, a Biztosító a biztosítási díjat a szerződőnek kamatmentesen visszautalja;
            </li>
            <li>
              bármely szóbeli közlés vagy kikötés akkor érvényes, ha azokat a Biztosító írásban
              megerősítette;
            </li>
            <li>
              a szerződés létrejöttéről szóló értesítés kézhezvételétől számított 14 napon belül
              indoklás nélkül felmondhatom a biztosítási szerződést;
            </li>
            <li>
              a Biztosító a Colonnade Minősített Fogyasztóbarát Otthonbiztosítás termékkel
              kapcsolatosan nem nyújt tanácsadást, a termék értékesítése pedig közvetlenül a
              biztosító online értékesítési felületén keresztül történik, az értékesítési
              folyamatban biztosításközvetítő nem működik közre.
            </li>
          </ul>
        </label>
      </div>
      <div class="form-check mb-4" v-if="merchant_id">
        <ValidationProvider name="biztositaskozvetito" rules="required_checkbox">
          <input
            type="checkbox"
            class="form-check-input"
            id="biztositaskozvetito"
            name="nyilatkozatok[]"
            value="biztositaskozvetito"
            v-model="validMerchant"
          />
        </ValidationProvider>
        <label for="biztositaskozvetito" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Amennyiben a biztosítási szerződést független biztosításközvetítő értékesíti, a
            biztosításközvetítő kijelenti, hogy az ügyletre megfelelő alkuszi megbízással
            rendelkezik.</b
          >
        </label>
      </div>
      <div class="form-check mb-4">
        <ValidationProvider name="valos_adatok" rules="required_checkbox">
          <input
            type="checkbox"
            class="form-check-input"
            id="valos_adatok"
            name="nyilatkozatok[]"
            value="valos_adatok"
            v-model="validDatas"
          />
        </ValidationProvider>
        <label for="valos_adatok" class="form-check-label">
          <span class="text-danger">*</span>&nbsp;
          <b
            >Nyilatkozat a szokásostól eltérő szerződési gyakorlat és a Ptk.-tól való eltérés
            elfogadásáról
            <button
              aria-label="valos-adatok-text-expand"
              @click="contractPracticeStatementClick"
              type="button"
            >
              <svg
                v-if="contractPracticeStatementOpened"
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="#b0001f"
                class="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z"
                />
              </svg>
              <svg
                v-else
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="32"
                fill="#b0001f"
                class="bi bi-caret-up-fill"
                viewBox="0 0 16 16"
              >
                <path
                  d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"
                />
              </svg></button
          ></b>
          <ul class="hyphens" v-show="contractPracticeStatementOpened">
            <b>Kijelentem, hogy:</b
            ><br />
            tájékoztatást kaptam arra vonatkozóan, hogy a Colonnade Minősített Fogyasztóbarát
            Otthonbiztosítás feltételeinek alábbi rendelkezései lényegesen eltérnek a Polgári
            Törvénykönyvről szóló 2013. évi V. törvény (Ptk.) vonatkozó rendelkezéseitől:
            <li>
              A Ptk. 6:466.§ (1) bekezdéstől eltérően a szerződő naptári negyedév végére is
              felmondhatja a szerződést, 30 napos felmondási határidővel. A szerződő e jogával a
              kockázatviselés kezdetét követő harmadik negyedév lejártát kezdődően.
            </li>
            <li>
              A Ptk. 6:466.§ (1) bekezdéstől eltérően, amennyiben a biztosító és a külső szolgáltató
              közötti szerződés, valamely okból megszűnik, a biztosítónak joga van az Assistance
              kiegészítő biztosítást az általános felmondási szabályoktól eltérő módon, szükség
              szerint időarányos díjvisszatérítés mellett, a külső szolgáltatóval fennállt szerződés
              megszűnésének időpontjára felmondani.
            </li>
            <li>
              A Ptk. 6:470 § (2) bekezdésétől eltérően a biztosító az eljárási költségeket nem
              előlegezi meg.
            </li>
            <li>
              A Ptk. 6:470.§ (3) bekezdésétől eltérően a biztosító a biztosítási összeg keretein
              belül téríti meg a kamatokat és az eljárási költségeket.
            </li>
            <li>
              A Ptk. 6:470.§ (3) bekezdésétől eltérően a biztosító a szerződésben megállapított
              limiten belül, a Szolgáltatási táblában (IV. Záradékok és függelékek) meghatározott
              limit erejéig téríti meg a biztosított képviseletét ellátó jogi képviselő – máshonnan
              meg nem térülő – igazolt munkadíját és készkiadásait, illetve a jogi védekezés egyéb
              költségeit. E biztosítási fedezet annyiban áll fenn az ésszerű, indokolt és gazdaságos
              költségek tekintetében, amennyiben azok a biztosítási szerződés fedezete alá tartozó,
              kizáró rendelkezés hatálya alá nem eső és a biztosító részére szerződésszerűen
              bejelentett biztosítási eseménnyel összefüggésben merültek fel. A biztosító nem téríti
              meg ezeket a költségeket, ha a szerződő/biztosított maga látja el a jogi védelmét.
            </li>
            <li>
              A Ptk. 6:63. § (5) bekezdésétől eltérően nem válik a Biztosítási szerződés tartalmává
              a Felek esetleges korábbi szerződéses/üzleti gyakorlata, szokása, illetve a
              biztosítási üzletágban a hasonló jellegű szerződés alanyai által széles körben ismert
              és rendszeresen alkalmazott szokás.
            </li>
            <li>
              A Ptk. 6:470 § (1), illetve (3) bekezdésében foglaltak ellenére a biztosítási fedezet
              nem terjed ki a sérelemdíjra (kivéve a felelősségbiztosítás fedezet).
            </li>
            Kijelentem, hogy a Colonnade Minősített Fogyasztóbarát Otthonbiztosítás a szokásos
            szerződési gyakorlattól eltérő rendelkezéseit elfogadom, azokat magamra nézve
            kötelezőnek ismerem el.
          </ul>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
import {mapFields} from 'vuex-map-fields';
import Accesory from './components/Accesory';
import {parse as parseMoney} from 'vue-currency-input';

export default {
  components: {
    Accesory,
  },
  data() {
    return {
      insuranceTermsOpened: true,
      insuranceBondStatementOpened: false,
      contractPracticeStatementOpened: false,
    };
  },
  computed: {
    ...mapFields([
      'merchant_id',
      'statementSettings.privacyStatement',
      'statementSettings.insuranceTerms',
      'statementSettings.electronicCommunation',
      'statementSettings.marketingMails',
      'statementSettings.acceptTerms',
      'statementSettings.validMerchant',
      'statementSettings.validDatas',
      'generalInfo.propertyZip',
      'generalInfo.propertyName',
      'generalInfo.selectedPropertyName',
      'contractSettings.emailVerified',
      'contractSettings.emailVerifyToken',
      'contractSettings.merchantEmail',
    ]),
    ...mapFields({
      contractFor: 'generalInfo.contractFor',
      propertyType: 'generalInfo.propertyType',
      propertyOutskirts: 'generalInfo.propertyOutskirts',
      propertyPhysicalJob: 'generalInfo.propertyPhysicalJob',
      propertyOwnRight: 'generalInfo.propertyOwnRight',
      insurancePropertyFloor: 'insuranceProperty.floorArea',
      insurancePropertyInsurance: 'insuranceProperty.chosenInsurancePrice',
      insurancePropertyBuiltYear: 'insuranceProperty.builtYear',
      insurancePropertyResidents: 'insuranceProperty.residents',
      insurancePropertyWall: 'insuranceProperty.wallType',
      insurancePropertyRoof: 'insuranceProperty.roofType',
      sideBuildings: 'insuranceSideBuildings.list',
      sideBuildingsInsurance: 'insuranceSideBuildings.chosenInsurancePrice',
      valuablesUnder200: 'insurancePersonalGoods.valuablesUnder200',
      sideBuildingsGoodsPrice: 'insurancePersonalGoods.sideBuildingsGoodsPrice',

      acceptCalculatedInsurance: 'insurancePersonalGoods.acceptCalculatedInsurance',
      calculatedInsurancePrice: 'insurancePersonalGoods.calculatedInsurancePrice',
      allGoodsPrice: 'insurancePersonalGoods.allGoodsPrice',
      summaryInputs: 'insurancePersonalGoods.summaryInputs',
      priceType: 'insurancePersonalGoods.priceType',

      paymentOptionsType: 'paymentOptions.type',
      paymentOptionsFrequency: 'paymentOptions.frequency',
      electronicContact: 'electronicContact',
      electronicInsuring: 'electronicInsuring',

      riskStartDate: 'riskSettings.startDate',
      riskLocationName: 'riskSettings.locationName',
      riskLocationType: 'riskSettings.locationType',
      riskLocationHouseNumber: 'riskSettings.locationHouseNumber',
      riskLocationBuilding: 'riskSettings.locationBuilding',
      riskLocationTopography: 'riskSettings.locationTopography',

      contractLastName: 'contractSettings.lastName',
      contractFirstName: 'contractSettings.firstName',
      contractMotherChildName: 'contractSettings.motherChildName',
      contractBornName: 'contractSettings.bornName',
      contractBornCity: 'contractSettings.bornCity',
      contractBornDate: 'contractSettings.bornDate',
      contractEmail: 'contractSettings.email',
      contractPhoneNumberArea: 'contractSettings.phoneNumberArea',
      contractPhoneNumber: 'contractSettings.phoneNumber',
      contractPostAddressIsTheSame: 'contractSettings.postAddressIsTheSame',

      contractLocationZip: 'contractSettings.postAddress.locationZip',
      contractLocationCity: 'contractSettings.postAddress.locationCity',
      contractLocationName: 'contractSettings.postAddress.locationName',
      contractSelectedLocationName: 'contractSettings.postAddress.selectedLocationName',
      contractLocationType: 'contractSettings.postAddress.locationType',
      contractLocationHouseNumber: 'contractSettings.postAddress.locationHouseNumber',
      contractLocationBuilding: 'contractSettings.postAddress.locationBuilding',
      contractLocationTopography: 'contractSettings.postAddress.locationTopography',

      contractedIsInsured: 'insuredSettings.contractedIsInsured',
      insuredLastName: 'insuredSettings.lastName',
      insuredFirstName: 'insuredSettings.firstName',
      insuredMotherChildName: 'insuredSettings.motherChildName',
      insuredBornName: 'insuredSettings.bornName',
      insuredBornCity: 'insuredSettings.bornCity',
      insuredBornDate: 'insuredSettings.bornDate',
      insuredEmail: 'insuredSettings.email',
      insuredPhoneNumberArea: 'insuredSettings.phoneNumberArea',
      insuredPhoneNumber: 'insuredSettings.phoneNumber',

      propertyIsMortgaged: 'mortgageSettings.propertyIsMortgaged',
      mortgageCreditor: 'mortgageSettings.creditor',
      mortgageCreditorLocation: 'mortgageSettings.creditorLocation',
      mortgageId: 'mortgageSettings.mortgageId',
      mortgagePrice: 'mortgageSettings.mortgagePrice',
      mortgageCurrency: 'mortgageSettings.mortgageCurrency',
      mortgageStartDate: 'mortgageSettings.mortgageStartDate',
      mortgageEndDate: 'mortgageSettings.mortgageEndDate',
    }),
    chosenAccesories: function() {
      let accesories = {};

      Object.entries(this.$store.state.chooseableAccesories.selectableList).forEach((accesory) => {
        if (accesory[1]?.selected) accesories[accesory[0]] = accesory[1];
      });

      return accesories;
    },
    stringPropertyType: function() {
      switch (this.propertyType) {
        case 'tarsashaz':
          return 'Társasházi lakás';
        case 'csaladihaz':
          return 'Családi ház';
        case 'sorhaz':
          return 'Sorház';
        case 'ikerhaz':
          return 'Ikerház';
      }
    },
    stringPropertyOwnType: function() {
      switch (this.propertyOwnRight) {
        case 'sajat':
          return 'Saját tulajdon saját használatban';
        case 'sajat_berbe':
          return 'Saját tulajdon bérbe adva';
        case 'berlemeny':
          return 'Bérlemény';
      }
    },
    stringPaymentType: function() {
      switch (this.paymentOptionsType) {
        case 'csoportos':
          return 'Csoportos beszedési megbízás';
        case 'online':
          return 'Online bankkártyás fizetés';
        case 'atutalas':
          return 'Átutalás';
        case 'csekk':
          return 'Postai csekk';
      }
    },
    stringPaymentFrequency: function() {
      switch (this.paymentOptionsFrequency) {
        case 'eves':
          return 'Éves';
        case 'feleves':
          return 'Féléves';
        case 'negyedeves':
          return 'Negyedéves';
        case 'havi':
          return 'Havi';
      }
    },
    detailedInsurePrice: function() {
      let price = 0;
      for (const [key, value] of Object.entries(this.summaryInputs)) {
        if (typeof value == 'string') {
          const parsedInt = parseMoney(value, window.currencyInputOptions);
          if (parsedInt) price += parsedInt;
        }
      }
      return price;
    },
    paymentFrequentString() {
      const frequency = this.$store.state.paymentOptions.frequency;
      let stringFrequency;
      if (frequency == 'eves') stringFrequency = ' /év';
      else if (frequency == 'feleves') stringFrequency = ' /félév';
      else if (frequency == 'negyedeves') stringFrequency = ' /negyedév';
      else stringFrequency = ' /hó';
      return (
        this.$options.filters.currency(this.$store.state.gyakorisag_szerint_fizetendo_dij) +
        stringFrequency
      );
    },
  },
  methods: {
    insuranceTermsClick(e) {
      if (e) e.preventDefault();
      this.insuranceTermsOpened = !this.insuranceTermsOpened;
    },
    insuranceBondStatementClick(e) {
      if (e) e.preventDefault();
      this.insuranceBondStatementOpened = !this.insuranceBondStatementOpened;
    },
    contractPracticeStatementClick(e) {
      if (e) e.preventDefault();
      this.contractPracticeStatementOpened = !this.contractPracticeStatementOpened;
    },
    stringPropertyWall: function(str) {
      switch (str) {
        case 'tegla':
          return 'Tégla';
        case 'beton':
          return 'Beton';
        case 'ko':
          return 'Kő';
        case 'panel':
          return 'Panel';
        case 'konnyuszerk':
          return 'Könnyűszerkezetes';
        case 'fa':
          return 'Fa';
        case 'valyog':
          return 'Vályog';
        case 'vegyes':
          return 'Vegyes (vályog és szilárd)';
      }
    },
    stringPropertyRoof: function(str) {
      switch (str) {
        case 'cserep':
          return 'Cserép';
        case 'pala':
          return 'Pala';
        case 'nad':
          return 'Nád';
        case 'fazsindely':
          return 'Fazsindely';
        case 'szalma':
          return 'Szalma';
        case 'bitumen':
          return 'Bitumenes';
        case 'muanyag':
          return 'Műanyag';
        case 'fem':
          return 'Fém';
        case 'hullamlemez':
          return 'Bitumenes hullámlemez';
      }
    },
  },
  watch: {
    emailVerifyToken: function(value) {
      if (btoa(value) == this.$store.state.email_valid_code) this.emailVerified = true;
    },
  },
};
</script>

<style lang="scss" scoped>
$red: #e4002b;

ul.hyphens {
  list-style-type: none;
}

button {
  all: unset;
}

ul.hyphens > li:before {
  content: '–';
  position: absolute;
  margin-left: -1.1em;
}

.arrow-up {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;

  border-bottom: 10px solid $red;
  margin-left: 5px;
  display: inline-block;
  cursor: pointer;
}

.arrow-down {
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;

  border-top: 10px solid $red;
  display: inline-block;
  margin-left: 5px;
  cursor: pointer;
}
img {
  color: #e4002b;
}

.form-check-label {
  margin-top: -20px;
  margin-left: 5px;
}
</style>
